module.exports = __webpack_public_path__ + "4a51b73d00d3c75d5970c6fd3cc9ce9a.png";